<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M9.51955 25.9804V22.0195H38.4804V25.9804H9.51955Z" fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
